export enum Stats {
  GET_SITE_PAYOUT_STATS_REQUEST = '@stats/GET_SITE_PAYOUT_STATS_REQUEST',
  GET_SITE_PAYOUT_STATS_SUCCESS = '@stats/GET_SITE_PAYOUT_STATS_SUCCESS',
  GET_SITE_PAYOUT_STATS_FAIL = '@stats/GET_SITE_PAYOUT_STATS_FAIL',

  GET_USER_PAYOUT_STATS_REQUEST = '@stats/GET_USER_PAYOUT_STATS_REQUEST',
  GET_USER_PAYOUT_STATS_SUCCESS = '@stats/GET_USER_PAYOUT_STATS_SUCCESS',
  GET_USER_PAYOUT_STATS_FAIL = '@stats/GET_USER_PAYOUT_STATS_FAIL',

  GET_EMPLOYEE_PAYOUT_STATS_REQUEST = '@stats/GET_EMPLOYEE_PAYOUT_STATS_REQUEST',
  GET_EMPLOYEE_PAYOUT_STATS_SUCCESS = '@stats/GET_EMPLOYEE_PAYOUT_STATS_SUCCESS',
  GET_EMPLOYEE_PAYOUT_STATS_FAIL = '@stats/GET_EMPLOYEE_PAYOUT_STATS_FAIL',

  GET_TIP_ACCEPTANCE_PAYMENTS_PENDING_COUNT_REQUEST = '@stats/GET_TIP_ACCEPTANCE_PAYMENTS_PENDING_COUNT_REQUEST',
  GET_TIP_ACCEPTANCE_PAYMENTS_PENDING_COUNT_SUCCESS = '@stats/GET_TIP_ACCEPTANCE_PAYMENTS_PENDING_COUNT_SUCCESS',
  GET_TIP_ACCEPTANCE_PAYMENTS_PENDING_COUNT_FAIL = '@stats/GET_TIP_ACCEPTANCE_PAYMENTS_PENDING_COUNT_FAIL',

  GET_TIP_ACCEPTANCE_PAYMENT_STATS_REQUEST = '@stats/GET_TIP_ACCEPTANCE_PAYMENT_STATS_REQUEST',
  GET_TIP_ACCEPTANCE_PAYMENT_STATS_SUCCESS = '@stats/GET_TIP_ACCEPTANCE_PAYMENT_STATS_SUCCESS',
  GET_TIP_ACCEPTANCE_PAYMENT_STATS_FAIL = '@stats/GET_TIP_ACCEPTANCE_PAYMENT_STATS_FAIL',
}
